import React from 'react'
import { useNewsDetails, NewsDetailsProps } from './useNewsDetails'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import styles from './NewsDetails.module.scss'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'
import AuthorCard from 'components/AuthorCard/AuthorCard'
import Details from './Details/Details'
import LatestNews from './LatestNews/LatestNews'
import Tags from './Tags/Tags'
import NotFound from './NotFound/NotFound'
import Loader from 'components/Loader/Loader'

const NewsDetails: React.FC<NewsDetailsProps> = (props: NewsDetailsProps) => {
  const { newsDetails, latestNews, tags, isLoading } = useNewsDetails(props)

  const { t, i18n } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <InnerTitleSection
        title={t('newsDetails')}
        breadcrumbs={[
          {
            title: t('navHome'),
            link: `/${currentLanguage}`,
          },
          {
            title: t('navNews'),
            link: `/${currentLanguage}/News`,
          },
          {
            title: t('newsDetails'),
          },
        ]}
      />
      {newsDetails && newsDetails.length ? (
        <article className={styles['news-details']}>
          <div className='container'>
            {newsDetails && newsDetails.length && (
              <div className='row'>
                <Details details={newsDetails} isAr={isAr} styles={styles} />
                <div className='col-lg-4 col-xl-3'>
                  <AuthorCard
                    title='Author'
                    name={
                      isAr
                        ? newsDetails[0].author.nameAr
                        : newsDetails[0].author.nameEn
                    }
                    description={
                      isAr
                        ? newsDetails[0].author.bioAr
                        : newsDetails[0].author.bioEn
                    }
                    url={
                      newsDetails[0].author.url
                        ? newsDetails[0].author.url
                        : null
                    }
                    photo={newsDetails[0].author.photo}
                    isAr={isAr}
                  />
                  <LatestNews news={latestNews} isAr={isAr} t={t} />
                  <Tags tags={tags} isAr={isAr} />
                </div>
              </div>
            )}
          </div>
        </article>
      ) : (
        <NotFound message='No Data' />
      )}
    </main>
  )
}

export default NewsDetails
